import * as React from 'react'
import { getCatalogProductsTable } from '../../../Model/CatalogProduct'
import { observer, inject } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import UserStore from '../../../Stores/UserStore'
import { Link } from 'react-router-dom'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'

export interface ICatalogProductsPageProps {
    localizationStore?: LocalizationStore
    userStore?: UserStore
}

@inject('localizationStore')
@inject('userStore')
@observer
export default class CatalogProductsPage extends React.Component<ICatalogProductsPageProps> {
    render() {
        const { localizationStore, userStore } = this.props
        return (
            <div className="catalogProductsPage row page">
                <div className="col-12">
                    <h4>{localizationStore!.t('CatalogProductsPageHeader')}</h4>
                </div>
                <div className="col-12">
                    <PageSizeComponent />
                    <ExportToCsvComponent exportType={ExportType.CatalogProducts} />
                    {
                        getCatalogProductsTable()
                    }
                </div>
                <div
                    className="col-12"
                    hidden={
                        !(
                            userStore!.checkAdmin ||
                            userStore!.checkCreditConsultant ||
                            userStore!.checkCreditExpert ||
                            userStore!.checkCashierAdmin ||
                            userStore!.checkCreditGroupAdministrator ||
                            userStore!.checkCollectionGroupAdministrator ||
                            userStore!.checkCatalogProductAdministrator ||
                            userStore!.checkSuperAdmin
                        )
                    }
                >
                    <Link to="/catalogProduct">
                        {`${localizationStore!.t('Create')} ${localizationStore!.t('CatalogProduct')}`}
                    </Link>
                </div>
            </div>
        )
    }
}

//     !(!userStore!.checkAdmin || 
//     !userStore!.checkCashierAdmin || 
//     !userStore!.checkCollectionGroupAdministrator || 
//     !userStore!.checkCreditGroupAdministrator ||
//     !userStore!.checkCreditConsultant ||
//     !userStore!.checkCreditExpert)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/CatalogProduct/CatalogProductsPage.tsx